<template>
  <div
    class="container"
    :style="{
      backgroundImage: 'url( ' + bottomPic + ')',
      backgroundSize: 'cover',
      backgroundRepleat: 'no-repeat',
      backgroundPosition: 'center center',
    }"
  >
    <div class="mian">
      <div class="banner">
        <img :src="topPic" @load="loadImage" alt="" class="bannerMian" />
        <img :src="iconPic" alt="" class="icon" v-if="iconPic" />
      </div>
      <!-- 登录 -->
      <div class="count">
        <div
          class="city"
          v-if="
            !cityCode &&
            paramsData &&
            paramsData.params &&
            paramsData.params.token
          "
        >
          <div class="title">请选择您的所在城市</div>
          <div class="cityBox" @click="showPicker = true">
            <span>{{ city }}</span>
            <img src="../../../assets/img/rightU.png" alt="" />
          </div>
          <div @click="getCity" class="btn">确认</div>
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
              show-toolbar
              ref="picker"
              :columns="columns"
              @cancel="showPicker = false"
              @confirm="onConfirm"
              value-key="name"
            />
          </van-popup>
        </div>
        <!-- 券 -->
        <div
          class="ticket"
          v-if="promotionStatus == 2 && lists && lists.length && cityCode"
        >
          <ticket-list :lists="lists" @bottomScroll="bottomScroll"></ticket-list>
          <div class="buttonBox" id="boxBtn" ref="boxBtn">
            <div class="btn btntickite" @click="changes" v-if="!phone">
              <div>一键领取</div>
            </div>
            <div class="btn btntickited" v-if="phone">
              <div>已领取</div>
              <span>奖励已经发放至您的账户 {{ phone }}</span>
            </div>
            <div class="box">
              <div
                class="btn btngoBack"
                :class="[shareBtn ? 'mr' : '']"
                @click="goOrder()"
              >
                立即叫车
              </div>
              <div class="btn btnshare" @click="popShare()" v-if="shareBtn">
                {{ btnText }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            !cityCode &&
            paramsData &&
            paramsData.params &&
            !paramsData.params.token
          "
          class="ticket tickets"
        >
          <div @click="changes" class="btn btntickite">一键领取</div>
        </div>
        <!-- 未在活动中以及已领完 -->
        <div class="nodata" v-if="cityCode && endtickte">
          <p>

            <span>奖励已发完！您来晚了，下次再来吧！</span>
          </p>
          <div @click="goOrder" class="btn btngoBack">立即叫车</div>
        </div>
      </div>
      <div class="rule" v-if="content">
        <div class="title">活动规则</div>
        <div v-html="content"></div>
      </div>
      <div class="fixdBox" v-if="isbtnShow">
        <div class="btn btntickite" @click="changes" v-if="!phone">
          <div>一键领取</div>
        </div>
        <div class="btn btntickited" v-if="phone">
          <div>已领取</div>
          <span>奖励已经发放至您的账户 {{ phone }}</span>
        </div>
      </div>
    </div>
    <!--登录弹出层-->
    <main-login
      :showLogin="showLogin"
      @toLogin="onLogin"
      @toLoginClose="onLoginClose"
      :btnColor="btnColor"
      :shugen="paramsData && paramsData.params ? paramsData.params : null"
      :fontLogin="fontLogin"
    ></main-login>
    <!--分享展示太阳码-->
    <qrcode-pic
      :qrcodePicShow="qrcodePicShow"
      :params="paramsData && paramsData.params ? paramsData.params : null"
      :posterObj="posterObj"
      @setShow="getShow"
    ></qrcode-pic>
    <!-- <share-list-one
      :params="paramsData && paramsData.params ? paramsData.params : null"
      :sharePlatformList="sharePlatformList"
      :shareH5Obj="shareH5Obj"
      ref="child"
    ></share-list-one> -->
    <share-list-all
      :params="paramsData && paramsData.params"
      :sharePlatformList="sharePlatformList"
      ref="child"
    ></share-list-all>
    <end-active
      :key="timer"
      :promotiontype="promotionStatus"
      v-if="
        promotionStatus == 1 ||
        (cityCode && promotionStatus != 2) ||
        promotionStatus == 3 ||
        promotionStatus == 4 ||
        (cityCode && promotionStatus == 5)
      "
    ></end-active>
    <!-- 领取成功弹窗 -->
    <module
      :ModuleShow="ModuleShow"
      :phone="phone"
      @closeShowTickte="closeShowTickte"
      v-show="ModuleShow"
    >
    </module>
    <!-- 去意已决 -->
    <gobackModule
      :gobackIf="gobackIf"
      :params="paramsData && paramsData.params"
      @closeGoback="closeGoback"
      @getGoback="getGoback"
    ></gobackModule>
  </div>
</template>

<script>
import mobileType from "../../../utils/mobileType";
import { getActivityInfo } from "@/apis/activity/common";
import {
  getCommonGetCoupon,
  getCommonGetCouponList,
  getProvinceCity,
} from "@/apis/activity/ticketUniversal";
import util from "@/utils/util";
import ShareListOne from "../../../components/common/shareListOne";
import ShareListAll from "../../../components/share/shareListAll";
import MainLogin from "../../../components/common/mainLogin";
import TicketList from "./components/ticketList";
import module from "./components/module";
import EndActive from "../common/endActive";
import wx from "weixin-js-sdk";
import QrcodePic from "../common/qrcodePic";
import gobackModule from "./components/gobackModule";

export default {
  components: {
    QrcodePic,
    EndActive,
    TicketList,
    MainLogin,
    ShareListOne,
    module,
    gobackModule,
    ShareListAll,
  },
  data() {
    return {
      // type: 2, //1登录没有城市  3登录了有城市   4未登录没有城市 5 list为空
      promotionStatus: 2, //活动信息 活动状态 1 待开始 2 活动中 3 已下架 4 已结束 5 不满足城市要求 6 不满足活动人群要求
      showLogin: false, //登录显示框
      btnColor: "#f05259", //登录显示框-颜色
      fontLogin: {
        titleLogin: "手机号填写",
        tipsLogin: "",
        btnLogin: "登录",
      }, //登录文案

      phone: "",
      activityId: "",
      cityCode: null,
      paramsData: null,

      source: null, //业务类型 900:顺风车  200:快车  400:专车  600:拼车  800:代驾  500:货运  300:出租车  801:代驾司机(传对应数值)
      qrcodePicShow: false, //分享太阳码
      posterObj: {
        activityId: this.$route.query.activityId, //活动id
        page: "pages/index/index", //要扫的太阳码页面路径
        // page: "active/pages/commonWeb/commonWeb", //要扫的太阳码页面路径
        outreachChannelCode: null, //渠道
        // src: "https://carpool-1301582899.cos.ap-guangzhou.myqcloud.com/image/appletcode/89RX-1630741577101.png",
      },

      ModuleShow: false, //一键领取-成功-弹窗
      tickite: false, //是否领取
      userInfo: {},
      userStatus: {},
      cityType: null, //活动城市范围
      content: "", //活动信息
      topPic: "",
      bottomPic: "",
      iconPic: "",
      qrcodePic: "", //分享二维码图
      city: "请选择城市",
      cityCode: "",
      cityCodeJk: "",
      showPicker: false,
      columns: [],
      lists: [], //领取券列表
      shareBtn: false, //分享按钮的展示
      btnText: "分享好友", //分享按钮的文案
      showShare: false, //分享开关
      schemeUrlIndexDj: "wsjc://800/home",
      sharePlatformList: [
        {
          title: "万顺代驾 随叫随到",
          url: window.location.origin, //分享链接-window.location.href
          imgUrl: this.$commonUrl.cos() + "/image/shareDj.png",
          description: "万顺代驾 随叫随到",
          userName: "gh_abcc55f26797", //小程序原始id
          path: "active/pages/commonWeb/commonWeb", //小程序路径
          miniprogramType:
            window.location.origin == "https://designated.wsecar.com" ? 0 : 2, //小程序 —— 0=正式版，1=测试版，2=体验版
          platformTag: 3, // 1 = QQ好友，2= QQ空间,3= 微信好友，4= 微信朋友圈，5= 保存图片，6=新浪微博(预留，暂不实现)，7=启动小程序
          shareType: 2, //分享类型（1=分享H5，2=小程序，3=分享图片）
        },
        {
          title: "代驾司机招募中",
          url: window.location.origin + "/home/ticketUniversal?platform=4", //分享链接-window.location.href
          imgUrl: this.$commonUrl.cos() + "/image/recruiting/bigshare.png", //platformTag=5时，优先取imgBase64可选择传imgUrl或imgBase64,其他的值都可以不传哈
          description: "收入由你，赚钱更自由！快来解锁新“钱”途",
          userName: "gh_abcc55f26797", //小程序原始id
          path: "active/pages/commonWeb/commonWeb", //小程序路径
          miniprogramType:
            window.location.origin == "https://designated.wsecar.com" ? 0 : 2, //小程序 —— 0=正式版，1=测试版，2=体验版
          platformTag: 4, // 1 = QQ好友，2= QQ空间,3= 微信好友，4= 微信朋友圈，5= 保存图片，6=新浪微博(预留，暂不实现)，7=启动小程序
          shareType: 3, //分享类型（1=分享H5，2=小程序，3=分享图片）
        },
      ],
      shareH5Obj: {
        shareH5Title: "万顺代驾 随叫随到", // H5分享标题
        shareH5Link: window.location.href, //H5分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        shareH5ImgUrl: this.$commonUrl.cos() + "/image/shareDj.png", // H5分享图标
      },
      timer: "",
      boxBtntop: null, //按钮的高度
      isbtnShow: false, //bottom-一键领取
      gobackIf: false, //去意已决-弹窗
      endtickte: false, //领券结束 发完
      posterImgIf: false, //分享朋友圈的海报
    };
  },
  filters: {
    calcPriceFun(val) {
      return util.calcPriceL(val);
    },
  },
  created() {
    //Vue的方法给原生调用，则需要把方法挂在Window下面
    window.getDataFromNative = this.getDataFromNative;
    this.$toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0,
    });
  },
  mounted() {
    //超过一屏 按钮展示 滚动监听
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScrollx, true);
    });
    //返回来 监听返回
    let self = this;
    window.history.pushState(null, null, "");
    window.addEventListener("popstate", function (e) {
      window.history.pushState(null, null, "");
      //是否领取
      if (self.phone|| self.lists.length==0) {
        self.getGoback();
      } else {
        self.gobackIf = true;
      }
    });

    //获取公参
    this.paramsData = this.$apiFun.getPlatFromParams(this.$route.query);
    if (this.paramsData) {
      this.getDataFromNative();
    } else {
      this.$apiFun.getUserInfoFromApp();
    }
    //获取城市json
    this.provinceCity();
  },
  methods: {
    //APP交互后获取params
    getDataFromNative(params) {
      if (params) {
        this.paramsData = this.$apiFun.getParamsIosAndroid(
          params,
          this.$route.query
        );
      }
      if (this.paramsData.params.platform == 4) {
        //获取市
        this.cityCode = null;
      } else {
        this.cityCode = this.paramsData.paramsOther.cityCode;
      }
      //返回来 兼容安卓
      if (mobileType.isAndroid() && !this.paramsData.params.platform == 3) {
        setTimeout(() => {
          try {
            window.tbs_bridge.nativeExec("network", "type", 0, null);
          } catch (e) {
            console.error(e);
          }
        }, 1000);
      }
      this.infoCode();
    },
    // 埋点
    infoCode() {
      let params = { ...this.paramsData.params };
      let paramsOther = this.paramsData.paramsOther;
      console.log(params);
      console.log(paramsOther);
      if (paramsOther.activityId) {
        this.activityId = paramsOther.activityId;
        let url;
        if (this.source) {
          url =
            "active/pages/commonWeb/commonWeb?activeid=" +
            this.activityId +
            "&source=" +
            this.source;
        } else {
          url = "active/pages/commonWeb/commonWeb?activeid=" + this.activityId;
        }
        this.sharePlatformList[0].path = url;
        if (paramsOther.outreachChannelCode) {
          this.paramsData.params.outreachChannelCode =
            paramsOther.outreachChannelCode;
          url =
            "active/pages/commonWeb/commonWeb?activeid=" +
            this.activityId +
            "&channelid=" +
            paramsOther.outreachChannelCode;
          this.sharePlatformList[0].path = this.source
            ? url + "&source=" + source
            : url;
          //埋点
          // sensors.track("MarketActivityCommon", {
          //   activity_id: this.activityId,
          //   outreach_channel_code: paramsOther.outreachChannelCode,
          // });
        // } else {
          //埋点
          // sensors.track("MarketActivityCommon", {
          //   activity_id: this.activityId,
          // });
        }
      }
      //分享的小程序路径
      this.queryActivityFun();
    },
    //时间过滤
    formatDate(val) {
      return util.timestampToYMDHM(val);
    },
    // 按钮显示
    handleScrollx() {
      let height = document.documentElement.clientHeight;
      let scrollTop = document.documentElement.scrollTop;
      this.boxBtntop = document
        .getElementById("boxBtn")
        .getBoundingClientRect().top;
        console.log(this.boxBtntop )
      if (scrollTop + height < this.boxBtntop) {
        this.isbtnShow = true;
      } else {
        this.isbtnShow = false;
      }
    },

    //获取活动信息
    async queryActivityFun() {
      let params = { ...this.paramsData.params };
      let paramsOther = this.paramsData.paramsOther;

      params.data = {
        activityId: paramsOther.activityId,
        distributionCode: paramsOther.outreachChannelCode
          ? paramsOther.outreachChannelCode
          : null,
        cityCode: this.cityCode ? this.cityCode : null,
      };
      if (paramsOther.source == 801) {
        params.token = "";
        params.data.driverId = params.driverId ? params.driverId : null;
      } else {
        if (paramsOther.driverId) {
          params.token = "";
          params.data.driverId = paramsOther.driverId
            ? paramsOther.driverId
            : null;
        }
      }
      params.data = JSON.stringify(params.data);
      try {
        const data = await getActivityInfo(params);
        if (data.code == 1) {
          this.$toast.clear();
          console.log(JSON.parse(data.data));
          this.timer = new Date().getTime();
          let promotionStatus = JSON.parse(data.data).promotionStatus;
          // 活动状态 1 待开始 2 活动中 3 已下架 4 已结束 5 不满足城市要求 6 不满足活动人群要求
          this.promotionStatus = promotionStatus;
          this.cityType = JSON.parse(data.data).cityType;
          document.getElementsByTagName("title")[0].innerText = JSON.parse(
            data.data
          ).name;
          let datas = JSON.parse(data.data);
          this.$route.meta.title = datas.name;
          if (paramsOther.outreachChannelCode) {
            this.iconPic = datas.distributionUrl;
          }
          this.content = datas.content;
          if (datas.activitySpreadVo) {
            this.topPic = datas.activitySpreadVo.skinTopImg;
            this.bottomPic = datas.activitySpreadVo.skinBottomImg;
            if (this.paramsData.params.platform == 4 && !this.cityCode) {
            } else {
              this.receiveList();
            }
          }
          this.shareBtn =
            datas.activitySpreadVo.shareButton == 1 ? true : false;
          if (this.shareBtn) {
            this.sharePlatformList[1].imgUrl = datas.activitySpreadVo.posterImg;
            this.sharePlatformList[0].title = datas.activitySpreadVo.shareTitle;
            this.sharePlatformList[0].imgUrl = datas.activitySpreadVo.shareImg;
            this.btnText = datas.activitySpreadVo.shareButtonTitle;
            //活动分享海报
            this.popShareImg();
          }
        }
      } catch (error) {}
    },
    onLoginClose(showLogin) {
      this.showLogin = showLogin;
    },
    onLogin(showLogin, userInfo, userStatus) {
      this.showLogin = showLogin;
      this.paramsData.params.token = userInfo.token;
      this.queryActivityFun();
    },
    loadImage(){
       this.$nextTick(() => {
        this.boxBtntop = this.$refs.boxBtn.getBoundingClientRect().top;

        this.handleScrollx();
      });
    },
    //奖励列表
    async receiveList() {
      let params = { ...this.paramsData.params };
      let paramsOther = this.paramsData.paramsOther;
      let channel = null;
      if (this.paramsData.params.platform == 3) {
        channel = 2;
      } else {
        channel = 1;
      }
      params.data = {
        activityId: paramsOther.activityId,
        cityCode: paramsOther.cityCode,
        channel: channel,
        channelDistributionId: paramsOther.outreachChannelCode,
      };
      params.data = JSON.stringify(params.data);
      try {
        const data = await getCommonGetCouponList(params);
        if (data.code == 1) {
          this.lists = JSON.parse(data.data).couponList;

          if (this.lists.length == 0) {
            this.endtickte = true;
          } else {
            if (JSON.parse(data.data).isReceive == 1) {
              this.changes();
            }

            if (JSON.parse(data.data).getReward == 1) {
              this.phone = JSON.parse(data.data).phone;
            }
            //按钮位置
            this.$nextTick(() => {
              this.boxBtntop = this.$refs.boxBtn.getBoundingClientRect().top;
              this.handleScrollx();
            });
          }
        } else {
          this.$toast(data.msg);
        }
      } catch (error) {}
    },
    // bottomScroll() {
    //   this.$nextTick(() => {
    //     this.boxBtntop = this.$refs.boxBtn.getBoundingClientRect().top;

    //     this.handleScrollx();
    //   });
    // },
    //城市
    async provinceCity() {
      let params = { ...this.paramsData.params };
      let paramsOther = this.paramsData.paramsOther;
      params.data = {
        activityId: paramsOther.activityId,
      };
      params.data = JSON.stringify(params.data);
      try {
        const data = await getProvinceCity(params);
        if (data.code == 1) {
          this.columns = JSON.parse(data.data).list;
        }
      } catch (error) {}
    },
    async popShareImg() {
      let params = { ...this.paramsData.params };
      let paramsOther = this.paramsData.paramsOther;
      let scene = null;
      if (this.source) {
        scene = paramsOther.activityId + "&" + this.source;
      } else {
        scene = paramsOther.activityId;
      }
      let QRCodeObj = {
        scene: scene,
        page: "active/pages/commonWeb/commonWeb",
      };
      let imgUrl = await this.$apiFun.getAppletQRCodeFun(params, QRCodeObj);
      if (imgUrl) {
        let posterObj = {
          bgUrl: this.sharePlatformList[1].imgUrl,
          qrCodeUrl: imgUrl,
          locationX: 190,
          locationY: 550,
          imgWidth: 220,
          imgHeight: 220,
        };
        let imgUrlPoster = await this.$apiFun.getPosterFun(params, posterObj);
        this.sharePlatformList[1].imgUrl = imgUrlPoster;
        this.posterImgIf = true;
      }
    },
    //立即领取
    async receive() {
      let params = { ...this.paramsData.params };
      let paramsOther = this.paramsData.paramsOther;

      let channel = this.paramsData.params.platform == 3 ? 2 : 1;
      params.data = {
        activityId: paramsOther.activityId,
        cityCode: paramsOther.cityCode,
        channel: channel,
        channelDistributionId: paramsOther.outreachChannelCode,
      };
      params.data = JSON.stringify(params.data);
      try {
        const data = await getCommonGetCoupon(params);
        if (data.code == 1) {
          this.ModuleShow = true;
          this.phone = JSON.parse(data.data).phone;
          this.receiveList();
        } else if (data.code == 30060) {
          this.phone = JSON.parse(data.data).phone;
          this.$toast(data.msg);
        } else if (data.code == 30063) {
          this.endtickte = true;
        } else {
          this.$toast(data.msg);
        }
      } catch (error) {}
    },
    //选择城市确认
    getCity() {
      this.cityCode = this.cityCodeJk;
      if (!this.cityCodeJk) {
        this.$toast("请选择城市");
        return false;
      }
      if (!this.paramsData.params.token) {
        this.showLogin = true;
        return false;
      }
      this.queryActivityFun();
    },
    onConfirm(value) {
      let valueArray = this.$refs.picker.getValues();
      this.city = value[1];
      this.cityCodeJk = valueArray[1].code;
      this.showPicker = false;
    },
    //一键领券
    changes() {
      if (
        this.paramsData.params.platform == 4 &&
        !this.paramsData.params.token
      ) {
        //未登录
        this.showLogin = true;
      } else {
        this.receive();
      }
    },
    //去叫车
    goOrder() {
      if (
        this.paramsData.params.platform == 1 ||
        this.paramsData.params.platform == 2
      ) {
        this.$options.methods.jumpApp(this.schemeUrlIndexDj);
      } else if (this.paramsData.params.platform == 3) {
        //小程序里代驾业务线能直接跳代驾首页
        if (this.source == 800) {
          wx.miniProgram.reLaunch({
            url: "/pages/index/index",
          });
        } else {
          this.qrcodePicShow = true;
        }
      } else {
        this.qrcodePicShow = true;
      }
    },
    //分享弹窗关闭
    closeShow() {
      this.qrcodePicShow = false;
    },
    //太阳码
    getShow() {
      this.qrcodePicShow = false;
    },
    //一键领取--领取成功的关闭
    closeShowTickte() {
      this.ModuleShow = false;
    },
    //在考虑一下
    closeGoback() {
      this.gobackIf = false;
    },
    getGoback() {
      if (this.gobackIf) {
        this.closeGoback();
      }
      if (this.paramsData.params.platform == 3) {
        wx.miniProgram.navigateBack();
      } else {
        if (mobileType.isIOS()) {
          window.ios.finish();
        } else if (mobileType.isAndroid()) {
          window.Android.finish();
        }
      }
    },
    //分享
    getShare(showShare) {
      this.showShare = false;
    },
    popShare() {
      if (this.paramsData.params.platform == 4) {
        this.qrcodePicShow = true;
      } else {
        if (this.posterImgIf) {
          this.showShare = true;
          this.$refs.child.jumpPage();
        } else {
          this.$toast("海报正在生成中，请稍等~");
        }
      }
    },
    // 跳转打开app
    jumpApp(t) {
      try {
        let e = navigator.userAgent.toLowerCase(),
          n = e.match(/cpu iphone os (.*?) like mac os/);
        if (
          ((n = null !== n ? n[1].replace(/_/g, ".") : 0), parseInt(n) >= 9)
        ) {
          window.location.href = t;
        } else {
          const r = document.createElement("iframe");
          (r.src = t), (r.style.display = "none"), document.body.appendChild(r);
        }
      } catch (e) {
        window.location.href = t;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  background: #f05259;
  padding-bottom: 1rem;

  .mian {
    width: 100%;

    .banner {
      width: 100%;
      position: relative;

      .bannerMian {
        width: 100%;
        height: auto;
      }

      .icon {
        width: 100%;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .count {
      padding: 10px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(96, 108, 133, 0.08);
      border-radius: 10px;
      margin: 0 10px;

      .title {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        line-height: 40px;
        text-align: center;
      }

      .tip {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        text-align: center;
      }

      .ticket {
        .buttonBox {
          margin: 0 32px;
        }
        .btn {
          box-sizing: border-box;
          height: 44px;
          width: 100%;
          border-radius: 48px;
          font-size: 18px;
          font-weight: 600;
          margin: 0 auto;
          text-align: center;
          line-height: 44px;
          margin-bottom: 10px;
          color: #ffffff;
        }
        .btntickite {
          background: linear-gradient(
            180deg,
            #ffdf88 0%,
            #ff8e64 10%,
            #fe0602 100%
          );
          box-shadow: 0px 2px 5px 0px #ff9e96;
        }
        .btntickited {
           background: linear-gradient(
            180deg,
            #FFE5DB  0%,
            #FFC2C1 100%
          );
          border-radius: 48px;
          line-height: inherit;
          color: #f26664;
          display: flex;
          flex-direction: column;
          div {
            font-size: 18px;
          }
          span {
            font-size: 12px;
            font-weight: 300;
          }
        }
        .box {
          // display: grid;
          // grid-template-columns: auto auto ;
          // grid-column-gap: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .btngoBack {
          height: 44px;
          background: linear-gradient(180deg, #ffe33b 0%, #fda302 100%);
          box-shadow: 0px 2px 5px 0px rgba(255, 166, 150, 0.82);
          border-radius: 48px;
          color: #664400;
        }
        .mr {
          margin-right: 10px;
        }
        .btnshare {
          font-weight: 600;
          background: linear-gradient(180deg, #9ce9c1 0%, #3aca7e 100%);
          box-shadow: 0px 2px 5px 0px #89f2bd;
        }
      }

      .tickets {
        .btn {
          margin-top: 10px;
        }
      }

      .nodata {
        p {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          padding: 20px;
          text-align: center;

          span {
            display: block;
          }
        }

        .btn {
          background: #ffbf54;
          width: 284px;
          height: 44px;
          border-radius: 44px;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          margin: 0 auto;
          text-align: center;
          line-height: 44px;
          margin-bottom: 20px;
        }
        .btngoBack {
          height: 44px;
          background: linear-gradient(180deg, #ffe33b 0%, #fda302 100%);
          box-shadow: 0px 2px 5px 0px rgba(255, 166, 150, 0.82);
          border-radius: 48px;
          color: #664400;
        }
      }

      .city {
        .cityBox {
          width: 258px;
          height: 24px;
          background: #f9f9f9;
          border-radius: 8px;
          margin: 20px auto;
          padding: 13px 11px;
          display: flex;
          justify-content: space-between;
          border: 1px solid #666;
          img {
            width: 20px;
            height: 20px;
          }
        }

        .btn {
          background: #ffbf54;
          width: 284px;
          height: 44px;
          border-radius: 44px;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          margin: 0 auto;
          text-align: center;
          line-height: 44px;
          margin-bottom: 20px;
        }
      }
    }

    .rule {
      padding: 0 16px 20px;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(96, 108, 133, 0.08);
      border-radius: 10px;
      margin: 16px 10px 0 10px;
      font-size: 14px;
      color: #666;
      line-height: 28px;

      .title {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        line-height: 40px;
        text-align: center;
      }
    }
    .fixdBox {
      position: fixed;
      width: 100%;
      border-top: 1px solid #eee;
      padding: 20px 0;
      bottom: 0;
      background: #fff;

      .btn {
        box-sizing: border-box;
        height: 44px;
        width: 80%;
        border-radius: 48px;
        font-size: 18px;
        font-weight: 600;
        margin: 0 auto;
        text-align: center;
        line-height: 44px;
        margin-bottom: 10px;
        color: #ffffff;
      }
      .btntickite {
        background: linear-gradient(
          180deg,
          #ffdf88 0%,
          #ff8e64 10%,
          #fe0602 100%
        );
        box-shadow: 0px 2px 5px 0px #ff9e96;
      }
      .btntickited {
        background: RGBA(255, 207, 200, 1);
        border-radius: 48px;
        line-height: inherit;
        color: #f26664;
        display: flex;
        flex-direction: column;
        div {
          font-size: 18px;
        }
        span {
          font-size: 12px;
          font-weight: 300;
        }
      }
    }
  }
}
</style>


